import {
  radioSchema,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { apportionmentInformationText } from '../../definitions/constants';
import {
  FIELDS,
  PARENT,
  YES_NO,
  buildReasonPageDescriptionSchema,
  buildReasonPageDescriptionUI,
  noPriorAnswerYes,
} from './helpers';

const DESCRIPTION_FIELD = 'view:beneficiaryRestrictedAreaDescription';

export default {
  path: 'beneficiary-restricted-area',
  title: apportionmentInformationText.beneficiaryRestrictedAreaPageTitle,
  depends: formData =>
    noPriorAnswerYes(formData, [
      FIELDS.veteranIncarceratedOver60Days,
      FIELDS.survivingBeneficiaryIncarceratedOver60Days,
      FIELDS.veteranIncompetentInCare,
      FIELDS.veteranReceivingPensionInCare,
    ]),
  uiSchema: {
    ...titleUI(apportionmentInformationText.beneficiaryRestrictedAreaPageTitle),
    ...buildReasonPageDescriptionUI(
      DESCRIPTION_FIELD,
      apportionmentInformationText.reasonPageSubDescription,
    ),
    [PARENT]: {
      [FIELDS.beneficiaryInEnemyTerritory]: radioUI({
        title: apportionmentInformationText.beneficiaryInEnemyTerritoryTitle,
        labels: apportionmentInformationText.yesNoLabels,
        errorMessages: {
          required:
            apportionmentInformationText.beneficiaryInEnemyTerritoryError,
        },
      }),
    },
  },
  schema: {
    type: 'object',
    properties: {
      ...buildReasonPageDescriptionSchema(DESCRIPTION_FIELD),
      [PARENT]: {
        type: 'object',
        properties: {
          [FIELDS.beneficiaryInEnemyTerritory]: radioSchema(YES_NO),
        },
        required: [FIELDS.beneficiaryInEnemyTerritory],
      },
    },
  },
};
